import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

export function getSubjects(withCalendars?: boolean): JQueryPromise<modelsGet.ISubject[]>
{
    return api.get<modelsGet.ISubject[]>({
        endpoint: "api/subjects",
        data: {
            withCalendars: withCalendars
        }
    });
}

export function getSubject(id: number): JQueryPromise<modelsGet.ISubject>
{
    return api.get<modelsGet.ISubject>({
        endpoint: `api/subjects/${id}`
    });
}

export function getSubjectsByCalendarId(calendarId: number): JQueryPromise<modelsGet.ISubject[]>
{
    return api.get<modelsGet.ISubject[]>({
        endpoint: `api/subjects/calendars/${calendarId}`
    });
}

export function getSubjectTypes(): JQueryPromise<modelsGet.ISubjectType[]>
{
    return api.get<modelsGet.ISubjectType[]>({
        endpoint: "api/subject-types"
    });
}

export function getSubjectType(id: number): JQueryPromise<modelsGet.ISubjectType>
{
    return api.get<modelsGet.ISubjectType>({
        endpoint: "api/subject-types",
        data: {
            id: id
        }
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(subject: modelsPost.ISubject): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/subjects/create",
        data: JSON.stringify(subject)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: number, subject: modelsPost.ISubject): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/subjects/edit/${id}`,
        data: JSON.stringify(subject)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/subjects/delete/${id}`
    });
}